<footer
  class="footer"
  [ngClass]="{ sponsors: footerConfig.showSponsors }"
>
  <div
    class="sponsors-container container"
    id="sponsors-container"
  >
    <div class="text-center">
      @if (footerConfig.showSponsors) {
        <div class="adressbox logos-sponsors">
          <span class="sponsors-caption">{{ 'footer.sponsorsCaption' | translate }}</span>
          @for (logo of footerConfig.sponsorLogos; track logo) {
            <span
              class="logo"
              [ngStyle]="{ backgroundImage: getLogoCSSLink(logo.name), width: getLogoCSSWidth(logo.width) }"
            ></span>
          }
        </div>
      }
      @if (footerConfig.linkedIn || footerConfig.instagram || footerConfig.facebook) {
        <div class="adressbox icon-only">
          @if (footerConfig.linkedIn) {
            <span
              ><a
                href="{{ footerConfig.linkedIn }}"
                target="_blank"
                ><i class="fa-brands fa-linkedin"></i></a
            ></span>
          }
          @if (footerConfig.instagram) {
            <span
              ><a
                href="{{ footerConfig.instagram }}"
                target="_blank"
                ><i class="fab fa-instagram"></i></a
            ></span>
          }
          @if (footerConfig.facebook) {
            <span
              ><a
                href="{{ footerConfig.facebook }}"
                target="_blank"
                ><i class="fab fa-facebook"></i></a
            ></span>
          }
        </div>
      }
      <div class="adressbox">
        <span><i class="fa fa-map-marker"></i>{{ footerConfig.customer }}</span>
        <span
          ><i class="fa fa-phone"></i>{{ 'footer.phone' | translate }}
          <a href="tel:{{ footerConfig.phoneNrLink }}">{{ footerConfig.phoneNr }}</a></span
        >
        <span
          ><i class="fa fa-globe"></i>
          <a
            href="https://{{ footerConfig.website }}"
            target="_blank"
            >{{ footerConfig.website }}</a
          ></span
        >
        <span
          ><i class="fa fa-envelope"></i> <a href="mailto:{{ footerConfig.email }}">{{ footerConfig.email }}</a></span
        >
      </div>
    </div>
  </div>
</footer>
